import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, MenuController, ModalController } from '@ionic/angular';

import { AppearanceService } from 'src/app/services/appearance/appearance.service';
import { ClientService } from 'src/app/services/client/client.service';
import { UserService } from 'src/app/services/user/user.service';
import { JobService } from 'src/app/services/job/job.service';

import { ModalAssignableAssetComponent } from 'src/app/components/modal-assignable-asset/modal-assignable-asset.component';
import { ModalNewLocationComponent } from '../../components/modal-new-location/modal-new-location.component';

import { AssetModel } from 'src/app/models/asset.model';
import { JobModel } from 'src/app/models/job.model';

import { Constants } from 'src/app/constants/constants';
import { format, parseISO } from 'date-fns';
import { AssetTypeModel } from 'src/app/models/asset-type.model';



@Component({
  selector: 'modal-create-heic-job',
  templateUrl: './modal-create-heic-job.component.html',
  styleUrls: ['./modal-create-heic-job.component.scss'],
})
export class ModalCreateHeicJobComponent implements OnInit {

  job: JobModel = null;

  jobDateError: boolean = false;
  jobTypeError: boolean = false;
  jobStatusError: boolean = false;
  organisationError: boolean = false;
  visitNumberError: boolean = false;
  postCodeError: string = null;
  jobInformationError: string = null;
  clientOrderNumberError: boolean = false;
  modalOpen = false;
  modalTitle = "";
  

  constructor(private router: Router, public userService: UserService, 
    private modalController: ModalController, private alertController: AlertController,
    private menuController: MenuController, private appearanceService: AppearanceService,
    public clientService: ClientService, private jobService: JobService) { }



    ngOnInit()
    {
      this.job = new JobModel();
    }
    
    
    ionViewWillEnter()
    {
      this.job = new JobModel();
      this.job.jobDate = new Date().toISOString();
      this.job.jobDateReadable = format(parseISO(this.job.jobDate), 'do MMM yyyy HH:mm:ss');
      this.job.jobDateMysql = format(parseISO(this.job.jobDate), 'yyyy-MM-dd HH:mm:ss');
      this.job.visitNumber = 1;
      this.job.priority = 1;
      this.job.jobTypeUid = this.jobService.getCreatingJobTypeUid();
      this.job.locationName = "";
      this.job.addressOne = "";
      this.job.addressTwo = "";
      this.job.addressCity = "";
      this.job.postCode = "";
      this.job.clientOrderNumber = "";
      this.job.clientUid = this.clientService.getClientUid();
      this.job.userDesignerUid = this.userService.getUserUid();
      this.job.userDesignerName = this.userService.getUserName();

      this.job.organisationSelect = this.clientService.getSelectedOrganisation();

      this.job.jobId = this.job.organisationSelect.code + Date.now().toString();
      this.job.organisationUid = this.job.organisationSelect.uid;
      this.job.organisationName = this.job.organisationSelect.name;

      if (this.job.jobTypeUid == 1)
      {
        this.modalTitle = "New PPM Job";
      }
      else
      {
        this.modalTitle = "New Reactive Job";
      }
  
      var userFilter = this.clientService.getClientUserFilters();
  
      for (var i = 0; i < userFilter.length; i++)
      {
        if (userFilter[i].uid == this.userService.getUserUid())
        {
          this.job.userDesignerSelect = userFilter[i];
          this.job.userDesignerUid = this.job.userDesignerSelect.uid;
          this.job.userDesignerName = this.job.userDesignerSelect.name;
          break;
        }
      }

      var defaultsAssetTypes = this.clientService.getDefaultAssignableAssetTypesForOrganisation(this.job.organisationSelect.uid);

      for (var x = 0; x < defaultsAssetTypes.length; x++)
      {
        var assetTypeUid = defaultsAssetTypes[x].assetTypeUid;
        var found = false;

        for (var i = 0; i < this.job.assignableAssetTypes.length; i++)
        {
          if (this.job.assignableAssetTypes[i].assetTypeUid == assetTypeUid)
          {
            found = true;
          }
        }

        if (!found)
        {
          this.job.assignableAssetTypes.push(defaultsAssetTypes[x]);
        }
      }
      
      this.job.userDesignerDate = new Date().toISOString();
      this.job.userDesignerDateReadable = format(parseISO(this.job.userDesignerDate), 'do MMM yyyy HH:mm:ss');
      this.job.userDesignerDateMysql    = format(parseISO(this.job.userDesignerDate), 'yyyy-MM-dd HH:mm:ss');
  
  
      this.menuController.enable(false);
      this.menuController.swipeGesture(false);
  
      this.jobTypeError = this.jobStatusError = 
      this.visitNumberError = this.organisationError = false;
  
      this.postCodeError = null;
    }
  
  
    ionViewWillLeave()
    {
      this.menuController.enable(true);
      this.menuController.swipeGesture(true);
    }
  
  
    async backButtonClicked() 
    {
      const alert = await this.alertController.create({
        header: 'Are you sure you want to cancel this job?',
        buttons: [
          {
            text: 'No',
            role: 'cancel',
            handler: () => {
  
            },
          },
          {
            text: 'Yes',
            role: 'confirm',
            handler: (data) => {
              
              this.goBackToJobsList();
  
            },
          },
        ],
      });
  
      await alert.present();
    }
  
  
    goBackToJobsList()
    {
      this.closeModal(null);
    }
  
    userDesignerSelected()
    {
      this.job.userDesignerUid = this.userService.getUserUid(); //this.job.userDesignerSelect.uid;
      this.job.userDesignerName = this.userService.getUserName(); //this.job.userDesignerSelect.name;
    }
  
    userDesignerDateChanged()
    {
      this.job.userDesignerDateReadable = format(parseISO(this.job.userDesignerDate), 'do MMM yyyy HH:mm:ss');
      this.job.userDesignerDateMysql = format(parseISO(this.job.userDesignerDate), 'yyyy-MM-dd HH:mm:ss');
    }
  
    userInstallerSelected()
    {
      this.job.userInstallerUid = this.job.userInstallerSelect.uid;
      this.job.userInstallerName = this.job.userInstallerSelect.name;
    }
  
    userInstallerDateChanged()
    {
      this.job.userInstallerDateReadable = format(parseISO(this.job.userInstallerDate), 'do MMM yyyy HH:mm:ss');
      this.job.userInstallerDateMysql = format(parseISO(this.job.userInstallerDate), 'yyyy-MM-dd HH:mm:ss');
    }
  
    userManagerSelected()
    {
      this.job.userManagerUid = this.job.userManagerSelect.uid;
      this.job.userManagerName = this.job.userManagerSelect.name;
    }
  
    userManagerDateChanged()
    {
      this.job.userManagerDateReadable = format(parseISO(this.job.userManagerDate), 'do MMM yyyy HH:mm:ss');
      this.job.userManagerDateMysql = format(parseISO(this.job.userManagerDate), 'yyyy-MM-dd HH:mm:ss');
    }
  
    jobStatusSelected()
    {
      this.job.jobStatusUid = this.job.jobStatusSelect.uid;
      this.job.jobStatusName = this.job.jobStatusSelect.name;
    }
  
    jobDateChanged()
    {
      this.job.jobDateReadable = format(parseISO(this.job.jobDate), 'do MMM yyyy HH:mm:ss');
      this.job.jobDateMysql = format(parseISO(this.job.jobDate), 'yyyy-MM-dd HH:mm:ss');
    }
  
  
    unassignAllowedAssetFromJob(index)
    {
      if (this.job.assignableAssetTypes.length == 1)
      {
        this.job.assignableAssetTypes.splice(index, 1);
        this.job.assignableAssetTypes = new Array<AssetTypeModel>();
      }
      else
      {
        this.job.assignableAssetTypes.splice(index, 1);
      }
    }


    async createNewLocation() 
    {
      if (this.clientService.getClientOrganisations().length == 0)
      {
        this.appearanceService.presentToast("Please add at least one Organisation", Constants.TOAST_ERROR);
        return;
      }
      
      this.modalOpen = true;

      const modal = await this.modalController.create({
        component: ModalNewLocationComponent,
        backdropDismiss: false,
        componentProps: { },
        cssClass: 'full-screen-modal',
        id: 'NewLocationModal'
      });
  
      modal.onDidDismiss().then((response) => {
  
        this.modalOpen = false;

        if (response.data)
        {
          if (response.data.locationCreated)
          {
  
          }
        }
      })
  
      return await modal.present();
    }
  
  
    async addNewAssignableAsset()
    {
      this.modalOpen = true;

      const modal = await this.modalController.create({
        component: ModalAssignableAssetComponent,
        backdropDismiss: false,
        componentProps: {},
        cssClass: 'full-screen-modal',
        id: 'AssignAssetModal'
      });
  
      modal.onDidDismiss().then((response) => {
  
        this.modalOpen = false;

        if (response.data)
        {
          if (response.data.assignableAssetType)
          {
            this.job.assignableAssetTypes.push(response.data.assignableAssetType);
          }
        }
      })
  
      return await modal.present();
    }
  
  
    doesJobHaveErrors(): boolean
    {
      var errorFound = false;
  
      this.jobTypeError = this.jobStatusError = 
      this.visitNumberError = this.organisationError = this.clientOrderNumberError;
  
      this.postCodeError = null;
  
  
      if (this.job.visitNumber < 1)
      {
        this.visitNumberError = true;
        errorFound = true;
      }
  
      if (!this.job.jobTypeUid)
      {        
        this.jobTypeError = true;
        errorFound = true;
      }
      else
      {
        if(this.job.jobTypeUid == 2)
        {
          if(!this.job.jobInformation)
          {
            this.jobInformationError = "Please enter Job Information.";
            errorFound = true;
          }
        }
      }
  
      if (!this.job.jobStatusUid)
      {
        this.jobStatusError = true;
        errorFound = true;
      }
  
      if (!this.job.organisationUid)
      {
        this.organisationError = true;
        errorFound = true;
      }

      if (!this.job.locationUid)
      {
        this.postCodeError = "Please find an address.";
        errorFound = true;
      }
      else
      {
        if (this.job.postCode.length < 3)
        {
          this.postCodeError = "Please enter a valid post code.";
          errorFound = true;
        }
      }
  
      return errorFound;
    }
  
  
    createNewJob()
    {
      if (this.doesJobHaveErrors())
      {
        return;
      }
  
      this.appearanceService.showLoading("Please wait...").then(() => {
  
        this.jobService.createNewJob(this.job).subscribe(response => {
  
          this.appearanceService.dismissLoading();
  
          if (response.Success)
          {
            var returnData = { newJobUid: response.JobUid };
            this.modalController.dismiss(returnData, null, 'CreateHeicJobModal');
          }
          else
          {
            if(response.Message.includes("Client Order Number"))
            {
              this.clientOrderNumberError = true;
            }

            this.appearanceService.presentToast(response.Message, Constants.TOAST_INFO);
          }
      
        },
        err => 
        {
          this.appearanceService.dismissLoading();
          this.appearanceService.presentToast("Failed to create job.", Constants.TOAST_ERROR);
        });
      });
    }
  
  
    findAddress()
    {
      this.postCodeError = null;
  
      if (!this.job.organisationUid)
      {
        this.postCodeError = "Please choose your organisation first.";
        return;
      }
  
      if (this.job.postCode == "")
      {
        this.postCodeError = "Please enter a post code.";
        return;
      }
  
      if (this.job.postCode.length < 2)
      {
        this.postCodeError = "Please enter a valid post code.";
        return;
      }
  
      this.appearanceService.showLoading("Finding Address...").then(() => {
  
        this.jobService.getAddressesFromPostCode(this.job.postCode, this.job.organisationUid).subscribe(response => {
  
          this.appearanceService.dismissLoading();
  
          if (response.addresses.length > 0)
          {
            this.presentAlertRadio(response.addresses);
          }
          else
          {
            this.appearanceService.presentToast("No Addresses found.", Constants.TOAST_INFO);
          }
      
        },
        err => 
        {
          this.appearanceService.dismissLoading();
          this.appearanceService.presentToast("Address Lookup Failed.", Constants.TOAST_ERROR);
        });
      });
    }
  
  
    async presentAlertRadio(addresses) 
    {
      var choices = new Array();
  
      for (var i = 0; i < addresses.length; i++)
      {
        var formattedAddress = addresses[i].locationName + ", " + addresses[i].line_1 + ", " + addresses[i].line_2 + ", " + addresses[i].town_or_city  + ", " + addresses[i].postCode;
  
        var newChoice =
        {
          name: i,
          type: 'radio',
          label: formattedAddress,
          value: i
        }
  
        choices.push(newChoice);
      }
      
      const alert = await this.alertController.create({
        cssClass: 'address-choice-alert',
        header: 'Choose Address',
        inputs: choices,
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            cssClass: 'secondary',
            handler: () => {
  
            }
          }, {
            text: 'Select',
            handler: (data) => {
  
              //building_name: ""
              //building_number: "6"
              //country: "England"
              //county: "Northamptonshire"
              //district: "Northampton"
              //formatted_address: "Flat 1, 6 Watkin Terrace, , , , Northampton, Northamptonshire"
              //line_1: "Flat 1"
              //line_2: "6 Watkin Terrace"
              //line_3: ""
              //line_4: ""
              //locality: ""
              //sub_building_name: ""
              //sub_building_number: ""
              //thoroughfare: "Watkin Terrace"
              //town_or_city: "Northampton"
  
              if (data != null)
              {
                var location = addresses[data];
  
                if (location)
                {
                  this.job.locationUid = location.locationUid;
                  this.job.locationName = location.locationName;
                  this.job.addressOne   = location.line_1;
                  this.job.addressTwo   = location.line_2;
                  this.job.addressCity  = location.town_or_city;
                  this.job.postCode     = location.postCode;
                }
              }
            }
          }
        ]
      });
  
      await alert.present();
    }
  
  
    clearUserManagerDate()
    {
      this.job.userManagerDate = null;
      this.job.userManagerDateReadable = null;
      this.job.userManagerDateMysql = null;
    }
  
    clearUserInstallerDate()
    {
      this.job.userInstallerDate = null;
      this.job.userInstallerDateReadable = null;
      this.job.userInstallerDateMysql = null;
    }
  
    clearUserDesignerDate()
    {
      this.job.userDesignerDate = null;
      this.job.userDesignerDateReadable = null;
      this.job.userDesignerDateMysql = null;
    }
  
    clearUserManager()
    {
      this.job.userManagerName = null;
      this.job.userManagerSelect = null;
      this.job.userManagerUid = null;
    }
  
    clearUserInstaller()
    {
      this.job.userInstallerName = null;
      this.job.userInstallerSelect = null;
      this.job.userInstallerUid = null;
    }
  
    clearUserDesigner()
    {
      this.job.userDesignerName = null;
      this.job.userDesignerSelect = null;
      this.job.userDesignerUid = null;
    }


  closeModal(returnData = null)
  {
    this.modalController.dismiss(returnData, null, 'CreateHeicJobModal');
  }
}